"use client";
import Image from "next/image";
import Link from "next/link";
import { Layout } from "@/components/Layout/Layout";
import { HeroBanner } from "@/components/HeroBanner/HeroBanner";
import { SectionHeading } from "@/components/SectionHeading/SectionHeading";
import HTMLReactParser from "html-react-parser";
import { getImageSrc } from "@/app/utils/getImageSrc";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export default function Wrapper({ pageData }) {
	return (
		<Layout>
			<HeroBanner image={getImageSrc(pageData.banner.image.url)} title={HTMLReactParser(pageData.banner.title)} about={HTMLReactParser(pageData.banner.text)} mobileImage={getImageSrc(pageData.banner.mobileImage.url)} alt={pageData.banner.image?.alt || "Hindustan Power sustainability"} mobileAlt={pageData.banner.mobileImage?.alt || "Hindustan Power sustainability"} />
			<section className="pt-16 ">
				<div className="flex flex-col items-center gap-8">
					<div className="hp-container flex flex-col items-center">
						<SectionHeading heading={HTMLReactParser(pageData.commitment.title)} subHeading={HTMLReactParser(pageData.commitment.text)} />
					</div>

					<div className="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full">
						{pageData.commitment.blocks.map((block, key) => {
							const Wrapper = block.buttonUrl ? Link : "div";
							return (
								<Wrapper href={block.buttonUrl} className="flex flex-col justify-end items-start text-left bg-white group text-white relative min-h-[400px] lg:min-h-[550px] overflow-hidden group " key={key}>
									<div className="flex flex-col gap-4 py-16 px-16 z-20 text-left transition-all duration-500">
										<h4 className="text-[24px] lg:text-[30px] font-normal leading-[36px]">{block.title}</h4>
										{block.buttonText && block.buttonUrl ? (
											<h6 className="text-[18px]  lg:text-[16px] xl:text-[18px]  font-light flex gap-2 items-center">
												<span className="underline underline-offset-4">{block.buttonText}</span>
												<Image alt="Arrow icon" src="/arrow-right.svg" width={100} height={80} unoptimized className="w-3 h-3" />
											</h6>
										) : null}
									</div>
									<div className="absolute h-full w-full bg-black bg-opacity-50 z-10 top-0 left-0"></div>
									<Image alt={block.image?.alt || block.title} src={getImageSrc(block.image.url)} width={100} height={80} unoptimized className="w-full h-full object-cover object-center absolute top-0 left-0" />
								</Wrapper>
							);
						})}
					</div>
				</div>
			</section>

			<section className="">
				<div className=" relative xl:h-screen flex flex-col items-center justify-center py-32 lg:py-56 xl:py-40">
					<Image alt={pageData.sustainableDevelopment.image?.alt || "Sustainable development at Hindustan Power"} src={getImageSrc(pageData.sustainableDevelopment.image.url)} width={50} height={50} unoptimized className="object-center w-full object-cover absolute top-0 left-0 h-full" />
					<div className="absolute h-full w-full bg-black bg-opacity-30 z-10 top-0 left-0"></div>
					<div className="z-20 relative text-white hp-container w-full text-center flex justify-center">
						<SectionHeading heading={HTMLReactParser(pageData.sustainableDevelopment.title)} subHeading={HTMLReactParser(pageData.sustainableDevelopment.text)} className={"z-20 text-white"} />
					</div>
				</div>
			</section>

			<section className="py-16">
				<div className="hp-container flex flex-col items-center gap-8">
					<SectionHeading heading={HTMLReactParser(pageData.EHSInitiatives.title)} subHeading={HTMLReactParser(pageData.EHSInitiatives.text)} />
					<div className="w-full grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-5">
						<div className="flex gap-5 flex-wrap justify-center">
							{pageData.EHSInitiatives.initiatives.map((report, key) => {
								return (
									<Link className="bg-white text-black py-1.5 px-6 rounded-[30px] font-bold text-[14px] lg:text-[16px] xl:text-[18px]  inline-flex gap-2 items-center border border-[#D0D0D0]" href={report.doc ? getImageSrc(report.doc.url) : "#"} target="_black" key={key}>
										<Image alt="Sustainability report PDF icon" src="/pdf.svg" width={30} height={30} unoptimized className="object-contain" />
										<span>{report.title}</span>
									</Link>
								);
							}
							)}
						</div>

						<div className="">
							<div className="flex gap-5 flex-wrap justify-center ">
								<Link className="bg-white text-black py-1.5 px-6 rounded-[30px] font-bold text-[14px] lg:text-[16px] xl:text-[18px]  inline-flex gap-2 items-center border border-[#D0D0D0] flex-shrink-0" href="https://cms.hindustanpower.in/media/sustainability-report.pdf" target="_black">
									<Image alt="Sustainability report PDF icon" src="/pdf.svg" width={30} height={30} unoptimized className="object-contain" />
									<span>Sustainability Report</span>
								</Link>
							</div>
						</div>

						<div className="">
							<div className="flex gap-5 flex-wrap justify-center ">
								{pageData.arm.reports.map((report, key) => {
									return (
										<Link className="bg-white text-black py-1.5 px-6 rounded-[30px] font-bold text-[14px] lg:text-[16px] xl:text-[18px]  inline-flex gap-2 items-center border border-[#D0D0D0] flex-shrink-0" href={getImageSrc(report.doc.url)} target="_black" key={key}>
											<Image alt="Sustainability report PDF icon" src="/pdf.svg" width={30} height={30} unoptimized className="object-contain" />
											<span>{report.title}</span>
										</Link>
									);
								})}
							</div>
						</div>

						<div className="">
							<div className="flex gap-5 flex-wrap justify-center">
								{pageData.mrm.reports.map((report, key) => {
									return (
										<Link className="bg-white text-black py-1.5 px-6 rounded-[30px] font-bold text-[14px] lg:text-[16px] xl:text-[18px]  inline-flex gap-2 items-center border border-[#D0D0D0] flex-shrink-0" href={getImageSrc(report.doc.url)} target="_black" key={key}>
											<Image alt="Sustainability report PDF icon" src="/pdf.svg" width={30} height={30} unoptimized className="object-contain" />
											<span>{report.title}</span>
										</Link>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="py-16">
				<div className="hp-container flex flex-col items-center gap-8">
					<SectionHeading heading={HTMLReactParser("Environmental Clearances")} />
					<div className="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
						<p className="font-normal text-[14px] md:text-[16px] xl:text-[18px]  leading-[22px] md:leading-[26px] xl:leading-[26px]">
							<strong>Environmental Clearance - Phase 1</strong>{" "}— Environmental Clearance for 2 × 630 MW thermal power plant at Anuppur, Madhya Pradesh.
						</p>
						<Link className="bg-white text-black py-1.5 px-6 rounded-[30px] font-bold text-[14px] lg:text-[16px] xl:text-[18px] inline-flex gap-2 items-center border border-[#D0D0D0] flex-shrink-0 justify-center" href="https://cms.hindustanpower.in/media/environmental-clearance-phase-1.pdf"
							target="_blank">
							<Image alt="PDF" src="/pdf.svg" width={30} height={30} unoptimized className="object-contain" />
							<span>Environmental Clearance Phase-I</span>
						</Link>
					</div>

					<div className="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
						<p className="font-normal text-[14px] md:text-[16px] xl:text-[18px]  leading-[22px] md:leading-[26px] xl:leading-[26px]">
							<strong>Environmental Clearance - Phase 2</strong>{" "}— Environmental Clearance for the addition of 2 × 800 MW ultra-supercritical units at Anuppur, Madhya Pradesh.
						</p>
						<Link className="bg-white text-black py-1.5 px-6 rounded-[30px] font-bold text-[14px] lg:text-[16px] xl:text-[18px] inline-flex gap-2 items-center border border-[#D0D0D0] flex-shrink-0 justify-center" href="https://cms.hindustanpower.in/media/environmental-clearance-phase-2.pdf" target="_blank">
							<Image alt="PDF" src="/pdf.svg" width={30} height={30} unoptimized className="object-contain" />
							<span>Environmental Clearance Phase-II</span>
						</Link>
					</div>
				</div>
			</section>
		</Layout>
	);
}
